var exports = {
  "kL": "GroupDMAvatar.module__container___YXVNck",
  "kg": "GroupDMAvatar.module__statusDot___YXVNck",
  "O0": "GroupDMAvatar.module__iconImageContainer___YXVNck",
  "c4": "GroupDMAvatar.module__defaultIconContainer___YXVNck",
  "DE": "GroupDMAvatar.module__defaultIcon___YXVNck",
  "EQ": "GroupDMAvatar.module__multiAvatarContainer___YXVNck",
};

module.exports = exports;
